import axios from '@axios';
import { clearSession, getAccessToken, setTokens } from '@/services/SessionService';

const userTokenKey = 'userTokenPostRes'; // changed keys as they clashed with portal names locally (used in router also)
const userKey = 'userPostRes';
export default {
  namespaced: true,
  state: {
    user: null,
    token: getAccessToken(),
  },
  getters: {
    getLocalUser(state) {
      return state.user || JSON.parse(localStorage.getItem(userKey));
    },
    getLocalUserToken(state) {
      return state.token || getAccessToken();
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    // eslint-disable-next-line
    clearLocalUser({ commit }) {
      clearSession();
      localStorage.removeItem(userTokenKey);
      localStorage.removeItem(userKey);
      delete axios.defaults.headers.common.Authorization;
      commit('SET_TOKEN', null);
      commit('stats/SET_FILTERS', { // reset filters
        before: '',
        after: '',
        prisonId: '',
        prisonGroupId: '',
      }, { root: true });
    },
    // eslint-disable-next-line
    setLocalUser({ commit }, user) {
      localStorage.setItem(userKey, JSON.stringify(user));
      commit('SET_USER', user);
    },
    // eslint-disable-next-line
    setLocalUserToken({ commit }, token) {
      setTokens({ token });
      commit('SET_TOKEN', token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },
    setLocalUserTokens({ commit }, tokens) {
      setTokens(tokens);
      commit('SET_TOKEN', tokens.token);
      axios.defaults.headers.common.Authorization = `Bearer ${tokens.token}`;
    },
    setCurrentUserFromLocalStorage({ commit }) {
      const user = localStorage.getItem(userKey);

      if (user) {
        commit('SET_USER', JSON.parse(user));
      }
    },
  },
};
